import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { ApexOptions, ChartComponent } from 'ng-apexcharts'

import { ChartService } from 'src/app/core/services/chart.service';

@Component({
  selector: 'app-chart',
  standalone: true,
  imports: [CommonModule, ChartComponent],
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css'],
})
export class ApxChartComponent {

  @Input() title: string = '';
  @Input() type: string = 'line';
  @Input() chartOptions?: ApexOptions;
  @Input() categories?: string[] = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep', 'Oct', 'Nov', 'Dec'];
  @Input() series?: { name: string; data: number[] }[];
  @Input() donutseries: number[] = [];
  @Input() height: number = 340;
  @Input() width: string | number = '100%';
  @Input() containerStyle: Record<string, string> = {};

  private _svcchart = inject(ChartService);
  public donutOptions = this._svcchart.donut(['JIU','THAY','BOXE'], this.type == "donut" ? this.donutseries : [3,6,9]);

  private defaultOptions: ApexOptions = {
    series: [
      {
        name: '2025',
        data: [44,55,41,67,22,43,21,49,70]
      },
      {
        name: '2026',
        data: [61,75,81,70,52,68,82,95,120]
      }
    ],
    chart: {
      type: 'line',
      height: 340,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: true
      }
    },
    stroke: {
      curve: 'smooth',
      width: 3
    },
    dataLabels: {
      enabled: false
    },
    markers: {
      size: 4
    },
    grid: {
      strokeDashArray: 4
    },
    xaxis: {
      categories: [
        'Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep', 'Oct', 'Nov', 'Dec'
      ]
    },
    legend: {
      position: 'bottom'
    },
    tooltip: {
      shared: true,
      intersect: false
    }
  };

  get resolvedChartOptions(): ApexOptions {
    const base = {
      ...this.defaultOptions,
      ...(this.chartOptions ?? {})
    };

    const chart: any = {
      ...this.defaultOptions.chart,
      ...(this.chartOptions?.chart ?? {}),
      height: this.chartOptions?.chart?.height ?? this.height
    };

    const xaxis: any = {
      ...this.defaultOptions.xaxis,
      ...(this.chartOptions?.xaxis ?? {}),
      categories: this.chartOptions?.xaxis?.categories ?? this.categories ?? this.defaultOptions.xaxis?.categories ?? []
    };

    return {
      ...base,
      chart,
      xaxis,
      series: this.type == "donut" ? (this.donutseries ?? this.donutOptions.series): 
                                    (this.series ?? this.chartOptions?.series ?? base.series),
    };
  }
}
